import { FunctionComponent, ReactNode, useMemo, useRef } from 'react'
import styled from 'styled-components'
import { FOOTER_HEIGHT } from '@/components/common/footer'
import {
  IrmContentContext,
  IrmContentContextProps,
} from '@/components/layout/hooks/use-irm-content-context'
import {
  SIDER_COLLAPSED_WIDTH,
  SIDER_EXPANDED_WIDTH,
} from '@/components/layout/irm/irm-layout'
import useHeaderHeight from '@/hooks/use-header-height'
import { StyledContent } from '@/types/antd/styled-antd'
import { Nullable } from '@/types/nullable'

interface IrmContentProps {
  isCollapsed: boolean
  children: ReactNode
}

const IrmContent: FunctionComponent<IrmContentProps> = ({
  isCollapsed,
  children,
}) => {
  const containerRef = useRef<Nullable<HTMLDivElement>>(null)
  const headerHeight = useHeaderHeight()

  const irmContentContextProps = useMemo((): IrmContentContextProps => {
    return {
      containerRef,
      isSiderCollapsed: isCollapsed,
    }
  }, [isCollapsed, containerRef])

  return (
    <IrmContentContext.Provider value={irmContentContextProps}>
      <ContentWrapper
        headerHeight={headerHeight}
        isCollapsed={isCollapsed}
        ref={containerRef}
      >
        <StyleContent>{children}</StyleContent>
      </ContentWrapper>
    </IrmContentContext.Provider>
  )
}

export default IrmContent

const ContentWrapper = styled.div<IrmContentProps & { headerHeight: number }>`
  min-height: calc(
    100dvh - ${({ headerHeight }): number => headerHeight}px -
      ${FOOTER_HEIGHT}px
  );
  margin: ${({ headerHeight }): number => headerHeight}px 0 0
    ${({ isCollapsed }): number =>
      isCollapsed ? SIDER_COLLAPSED_WIDTH : SIDER_EXPANDED_WIDTH}px;
`

const StyleContent = styled(StyledContent)`
  overflow: initial;
`
